var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTtCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4957",
    "data-name": "Grupo 4957",
    transform: "translate(-10286 -4949)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_147",
    "data-name": "Elipse 147",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(10286 4949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-tiktok",
    "data-name": "Icon simple-tiktok",
    d: "M15.172.023C16.7,0,18.224.012,19.744,0A7.283,7.283,0,0,0,21.79,4.876a8.245,8.245,0,0,0,4.957,2.093V11.68a12.515,12.515,0,0,1-4.911-1.134,14.446,14.446,0,0,1-1.894-1.087c-.012,3.414.012,6.828-.023,10.23A8.93,8.93,0,0,1,18.341,24.3a8.711,8.711,0,0,1-6.91,3.753,8.525,8.525,0,0,1-4.77-1.2,8.817,8.817,0,0,1-4.268-6.676c-.023-.585-.035-1.169-.012-1.742a8.8,8.8,0,0,1,10.207-7.81c.023,1.73-.047,3.461-.047,5.191a4.012,4.012,0,0,0-5.121,2.479,4.638,4.638,0,0,0-.164,1.882,3.979,3.979,0,0,0,4.092,3.356,3.928,3.928,0,0,0,3.239-1.882,2.7,2.7,0,0,0,.479-1.239c.117-2.093.07-4.174.082-6.267.012-4.712-.012-9.412.023-14.112Z",
    transform: "translate(10296.632 4960)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtCircle);
export default __webpack_public_path__ + "static/media/TT-circle.09cd2e2ad9f97ff361e277cc9e610ca6.svg";
export { ForwardRef as ReactComponent };